import BaseApi from './base.api'
import { usePortalStore } from '@/stores/portal.store'

class GarageApi extends BaseApi {
  documentProgressStatusesUrl = 'document-progress-statuses/'
  eventsUrl = 'garage-events/'
  interventionTypesUrl = 'intervention-types/'
  garageReasonsUrl = 'garage-reasons/'
  quoteRowsUrl = 'quote-rows/'
  quotesUrl = 'quotes/'
  worksheetRowsUrl = 'worksheets-rows/'
  worksheetsUrl = 'worksheets/'
  workTimeEntriesUrl = 'work-time-entries/'

  constructor() {
    super('garage/')
  }

  batchDeleteQuotesAsync = (ids) => this.post(`${this.quotesUrl}batch-delete/`, { ids })
  batchDeleteQuoteRowsAsync = (ids) => this.post(`${this.quoteRowsUrl}batch-delete/`, { ids })
  batchDeleteWorksheetsAsync = (ids) => this.post(`${this.worksheetsUrl}batch-delete/`, { ids })
  batchDeleteWorksheetRowsAsync = (ids) => this.post(`${this.worksheetRowsUrl}batch-delete/`, { ids })
  batchDeleteWorkTimeEntriesAsync = (ids) => this.post(`${this.workTimeEntriesUrl}batch-delete/`, { ids })

  downloadQuoteVehicleVatFileAsync = (vehicleFileId, fileName) =>
    this.download(`${this.quotesUrl}vehicle-files/${vehicleFileId}`, fileName)

  downloadWorksheetVehicleVatFileAsync = (vehicleFileId, fileName) =>
    this.download(`${this.worksheetsUrl}vehicle-files/${vehicleFileId}`, fileName)

  getQuoteByIdAsync = (quoteId = null) => this.get(`${this.quotesUrl}${quoteId || ''}`)
  getQuoteDetailsAsync = (id, params, config = {}) => this.get(`${this.quotesUrl}${id}/details`, params, config)
  getQuotesAsync = (params) => this.get(this.quotesUrl, params)

  getWorksheetByIdAsync = (worksheetId = null) => this.get(`${this.worksheetsUrl}${worksheetId || ''}`)
  getWorksheetsAsync = (params) => this.get(this.worksheetsUrl, params)
  getWorksheetDetailsAsync = (id, params, config = {}) => this.get(`${this.worksheetsUrl}${id}/details`, params, config)
  getWorksheetsLastUpdateAsync = () => this.get(`${this.worksheetsUrl}last_update`)
  getEventsAsync = (params) => this.get(this.eventsUrl, params)

  getGarageReasonsAsync = () => this.get(this.garageReasonsUrl)
  getDocumentProgressStatusesAsync = () => this.get(this.documentProgressStatusesUrl)
  updateDocumentProgressStatusAsync = (id, data) => this.patch(`${this.documentProgressStatusesUrl}${id}/`, data)
  createDocumentProgressStatusAsync = (data) => this.post(this.documentProgressStatusesUrl, data)
  deleteDocumentProgressStatusByIdAsync = (id) => this.delete(`${this.documentProgressStatusesUrl}${id}/`)
  resetSettingsDocumentProgressStatusAsync = (id) => this.post(`${this.documentProgressStatusesUrl}reset_settings/`)

  getInterventionTypesAsync = () => this.get(this.interventionTypesUrl)

  getWorksheetNextIdByDataAsync = (data) => this.post(`${this.worksheetsUrl}next/`, data)
  getQuoteNextIdByDataAsync = (data) => this.post(`${this.quotesUrl}next/`, data)
  getQuoteNextCarServiceAsync = (vehicleId) => this.get(`${this.quotesUrl}next-filtered/`, { vehicle: vehicleId })

  generateWorksheetFromQuoteAsync = (data) => this.post(`${this.quotesUrl}generate-worksheet/`, data)
  generateWorksheetFromSchedulerAsync = (data) => this.post(`${this.eventsUrl}generate-worksheet/`, data)

  printQuotesAsync = (filename, data, config) => this.download(`${this.quotesUrl}print/`, filename, null, false, { ...config, method: 'post', data: data })
  printPreviewQuoteAsync = (data) => this.downloadBlob(`${this.quotesUrl}print/`, null, false, { method: 'post', data: data })
  reorderQuoteRowsAsync = (quoteId, data) => this.post(`${this.quoteRowsUrl}${quoteId}/reorder_row_numbers/`, data)
  reorderWorksheetRowsAsync = (worksheetId, data) => this.post(`${this.worksheetRowsUrl}${worksheetId}/reorder_row_numbers/`, data)

  printWorksheetsAsync = (filename, data, config) => this.download(`${this.worksheetsUrl}print/`, filename, null, false, { ...config, method: 'post', data: data })
  printPreviewWorksheetAsync = (data) => this.downloadBlob(`${this.worksheetsUrl}print/`, null, false, { method: 'post', data: data })

  createEventAsync = (data) => this.post(this.eventsUrl, data)
  deleteEventAsync = (id) => this.delete(`${this.eventsUrl}${id}/`)

  updateEventAsync = (id, data) => this.patch(`${this.eventsUrl}${id}/`, data)
  updateWorksheetAsync = (id, data, config = {}) => this.patch(`${this.worksheetsUrl}${id}/`, data, config)

  getQuoteDocumentRelationTreeAsync = (id) => this.get(`${this.quotesUrl}${id}/document-relation-tree/`, {document_type: usePortalStore().documentTypesEnum.GARAGE_QUOTE})
  getWorksheetDocumentRelationTreeAsync = (id) => this.get(`${this.worksheetsUrl}${id}/document-relation-tree/`, {document_type: usePortalStore().documentTypesEnum.GARAGE_WORKSHEET})

  createWorkTimeEntryAsync = (data) => this.post(this.workTimeEntriesUrl, data)
  updateWorkTimeEntryAsync = (id, data) => this.patch(`${this.workTimeEntriesUrl}${id}`, data)
}
export const garageApi = new GarageApi()
